import './polyfills';

import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';

import './index.css';
import { App } from './app';
import { Dff } from './dff/dff';
import { DffAnalyse } from './dff-analyse/dff-analyse';
import { SpaceUsage } from './space-usage/space-usage';
import { SpaceUsageAnalyse } from './space-usage-analyse/space-usage-analyse';
import { PdfToolComponent } from './pdf-tool/pdf-tool-component';
import { PdfToolManageComponent } from './pdf-tool-manage/pdf-tool-manage-component';
import { PdfToolSplitComponent } from './pdf-tool-split/pdf-tool-split-component';
import { PdfToolMergeComponent } from './pdf-tool-merge/pdf-tool-merge-component';
import { MergeToolComponent } from './pdf-tool-merge/pdf-tool-merge-tool-component';
import { EmptyFolders } from './eff/empty-folders';
import { EmptyFoldersAnalyse } from './eff-analyse/empty-folders-analyse';
import { setBaseUrl} from './dff/dff-slice';

import { BrowserRouter as Router, Route } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';

import { store } from './store/store';
import { Provider } from 'react-redux';
import { GuardedRoute } from './GuardedRoute';
import { fetchUser } from './user/user-slice';


const Root = ({ store }) => (
  <Provider store={store}>
    <Router>
      <Route exact path="/" component={App} />
      <Route exact path="/dff/" component={Dff} />
      <GuardedRoute path="/dff/:mountId" component={DffAnalyse}  />

      <Route exact path="/space-usage/" component={SpaceUsage} />
      <GuardedRoute exact path="/space-usage/:mountId" component={SpaceUsageAnalyse} />

      <Route exact path="/eff/" component={EmptyFolders} />
      <GuardedRoute exact path="/eff/:mountId" component={EmptyFoldersAnalyse} />

      <Route exact path="/pdf-tool/" component={PdfToolComponent} />
      {/* <GuardedRoute exact path="/pdf-tool/" component={PdfToolComponent} /> */}
      <Route exact path="/pdf-tool/split/" component={PdfToolSplitComponent} />
      <Route exact path="/pdf-tool/merge/" component={PdfToolMergeComponent} />
      <Route exact path="/pdf-tool/merge/tool/" component={MergeToolComponent} />
      <GuardedRoute exact path="/pdf-tool/split/:mountId" component={PdfToolManageComponent} />
    </Router>
    <ReactTooltip effect="solid" />
  </Provider>
);

fetch('/profile').then(res => res.json()).then(res => {
  store.dispatch(setBaseUrl(res.base));

  // For debugging
  (window as any).store = store;

  store.dispatch(fetchUser()).then(() => {
    const savedUrl = sessionStorage.getItem('currentPath')
    if (savedUrl) {
      sessionStorage.removeItem('currentPath')
      document.location.href = savedUrl
    }
    return (ReactDOM.render(<Root store={store}/>, document.getElementById('root')))
    }
  )
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
